import React from 'react';
import { withFormik } from 'formik';
import FormControl from 'components/Core/FormControl';
import { Col, Row } from 'components/Core/Grid';
import Button from 'components/Core/Button';
import HyperLink from 'components/Core/HyperLink';
import FormTextField from 'components/Page/Toolbox/FormTextField';
import passwordSchema, { passwordText } from 'components/Page/Toolbox/Schemas/password';
import SecurityQuestionSelect from 'components/Page/Toolbox/SecurityQuestionSelect';
import Text from 'components/Core/Text';
import { getFormValid } from 'utils/formUtils';
import { SignupContainer } from './styles';

const Signup2 = ({ onFinish, openLoginModal, onBack, errorMessage, ...otherProps }) => {
  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
    errors,
    isValid,
    touched,
    submitCount,
  } = otherProps;

  const formValid = getFormValid({ errors, submitCount });

  return (
    <SignupContainer>
      <h4>Create your password</h4>
      <div>
        <Text type="p">{passwordText}</Text>
        <FormTextField
          id="password"
          placeholderText="Password"
          values={values}
          onChange={handleChange}
          onBlur={handleBlur}
          type="password"
          formValid={formValid}
          formErrors={errors}
        />
        <FormTextField
          id="password2"
          placeholderText="Verify Password"
          values={values}
          onChange={handleChange}
          onBlur={handleBlur}
          type="password"
          formValid={formValid}
          formErrors={errors}
        />
        <SecurityQuestionSelect
          id="question"
          placeholder="Security Question"
          values={values}
          handleChange={(id, value) => setFieldValue(id, value)}
          formValid={formValid}
          formErrors={errors}
        />
        <FormTextField
          id="answer"
          placeholderText="Answer"
          values={values}
          onChange={handleChange}
          onBlur={handleBlur}
          formValid={formValid}
          formErrors={errors}
        />
        {errorMessage && (
          <FormControl>
            <p>
              <span className="input-failed-value">{errorMessage}</span>{' '}
              <HyperLink onClick={openLoginModal}>Sign in</HyperLink>
            </p>
          </FormControl>
        )}
        <Row gutter={20}>
          <Col xs={12}>
            <Button type="white" shadow={false} width="100%" onClick={() => onBack()} noSubmit>
              Back
            </Button>
          </Col>
          <Col xs={12}>
            <Button
              type="secondary"
              width="100%"
              shadow={false}
              button
              disabled={!isValid}
              onClick={handleSubmit}
            >
              Continue
            </Button>
          </Col>
        </Row>
      </div>
    </SignupContainer>
  );
};

export default withFormik({
  validationSchema: passwordSchema,
  handleSubmit: ({ errorMessage, ...values }, { props, setErrors }) => {
    props.onFinish(values);
  },
})(Signup2);
